import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { Injectable } from '@angular/core';
import { catchError, switchMap, take, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HandleExceptionsService } from 'src/app/services/exceptions/handle-exceptions/handle-exceptions.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authenticationService: AuthenticationService, private handleExceptionsService: HandleExceptionsService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    if (request.url.includes(environment.sgcApi) || request.url.includes(environment.reportApi)) {
      return this.authenticationService.getHeaders().pipe(
        take(1),
        switchMap(headers => {
            const httpRequest = request.clone({
              headers: headers
            });
            return next.handle(httpRequest).pipe(catchError(error => {
              return throwError(() => this.handleExceptionsService.handleError(error));
              }));
            }
          )
        )
      } else if (request.url.includes(environment.sgc1Url)) {
        request = request.clone({
          withCredentials: true,
        });
      }
      return next.handle(request);
  }
}
